import { render, staticRenderFns } from "./ModalSidebar.vue?vue&type=template&id=3336c1ff&scoped=true&"
import script from "./ModalSidebar.vue?vue&type=script&lang=js&"
export * from "./ModalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ModalSidebar.vue?vue&type=style&index=0&id=3336c1ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3336c1ff",
  null
  
)

export default component.exports